import React, {FC, useEffect, useState} from "react";
import {useTypedSelector} from "../reducers";
import axios from "axios";
import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Selection, LoadPanel } from "devextreme-react/data-grid";
import { useNavigate } from "react-router-dom";
import { handleError } from "../error/ErrorHandler";

const ShineRequestList: FC = () => {
    const { site } = useTypedSelector(state => state.profile);
    const { loginUser, status } = useTypedSelector(state => state.auth);
    const [ requestList, setRequestList ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const navigate = useNavigate()

    const getRequestList = async() => {
        try {
            const res = await axios.get('/api/data/user?usrId=' + loginUser?.usrId);
            if (res.data) setRequestList(res.data);
        } catch(err) {
            handleError(err);
        } finally {
            setLoading(false);
        }
    };

    const onSelectionChanged = (onSelectionChanged: any) => {
        const selectedDataId = onSelectionChanged.selectedRowsData[0].dataId;
        navigate('/request/list/' + selectedDataId);
    }

    useEffect(() => {
        if (status === 'idle') return;
        getRequestList();
    }, [ status ]);

    return (
        <div className={`board-content-wrapper ${site}`}>
            <div className={'board-content-body'}>
                { !loading && 
                    <DataGrid dataSource={requestList}
                            showColumnLines={false}
                            hoverStateEnabled={true}
                            onSelectionChanged={onSelectionChanged}
                            showRowLines={true}>
                        <LoadPanel enabled />
                        <SearchPanel visible={true} />
                        <Selection mode="single" />
                        <Column dataField={'dataId'} caption={'신청번호'} cssClass={'board-content-header text-center pointer'} />
                        <Column dataField={'rqstRsn'} caption={'연구목적'} cssClass={'board-content-header header-center pointer'} alignment={'center'} />
                        <Column dataField={'statusNm'} caption={'상태'} cssClass={'board-content-header header-center pointer'} alignment={'center'} />
                        <Column dataField={'usrNm'} caption={'작성자'} cssClass={'board-content-header header-center pointer'} alignment={'center'} />
                        <Column dataField={'loadDtm'} caption={'작성일'} cssClass={'board-content-header text-center pointer'}  />
                        <Scrolling rowRenderingMode={'virtual'} />
                        <Paging defaultPageSize={5}>
                            <Pager visible={true} />
                        </Paging>
                    </DataGrid>
                }
            </div>
        </div>
    );
}
export default ShineRequestList;

